import React from 'react';
import { VerificationForm } from '@sheerid/jslib';
import '@sheerid/jslib/sheerid.css';
import './App.css';

import { programId } from './programOptions';

// tslint:disable-next-line: function-name
function App() {
    return (
        <div className="sid-verification-form">
            <VerificationForm programId={programId} />
        </div>
    );
}

export default App;
